<template>
  <div>
    <List
      url="menus/"
      :title="title"
      titleClass="title"
      :tanle="tanle"
      :operat="operat"
      :update="updateList"
      :data="searchData"
      :afterList="dealList"
      @edit="edit"
      @deletedata="deletedata"
    >
      <div slot="Filter" style="display: flex;">
        <div class="item">
          <label>模块：</label>
          <el-input v-model="searchData.app" style="width:200px;"></el-input>
        </div>
        <div class="item">
          <label>页面：</label>
          <el-input
            v-model="searchData.menu_page"
            style="width:200px;"
          ></el-input>
        </div>

        <div class="item">
          <label>菜单名：</label>
          <el-input
            v-model="searchData.name"
            style="width:200px;margin-right:30px;"
          ></el-input>

          <el-button @click="updateList++" type="primary" size="small"
            >搜索</el-button
          >
        </div>
      </div>
      <template slot="Fresh">
        <el-button
          @click="add"
          type="primary"
          style="margin-bottom:10px;float:right"
          >新增</el-button
        >
      </template>
    </List>
    <UpdateBox
      :initForm="updateForm"
      :updateType="updateType"
      v-if="updateBlock"
      @close="close"
      @update="updateList++"
    ></UpdateBox>
  </div>
</template>
<script>
import List from "../components/common/List.vue";
import UpdateBox from "../components/PagePermission/UpdateBox.vue";
import { operatsList } from "@/components/Index/data.js";

export default {
  components: {
    List,
    UpdateBox
  },
  data() {
    return {
      tanle: [
        { name: "name", label: "菜单名" },
        { name: "url", label: "url" },
        { name: "actionName", label: "权限" },
        { name: "app", label: "模块" },
        { name: "menu_page", label: "页面" }
      ],
      title: "页面权限管理",
      operat: [
        {
          text: "Edit",
          eventName: "edit"
        },
        {
          text: "Deletedata",
          eventName: "deletedata"
        }
      ],
      searchData: {
        name: "",
        app: "",
        menu_page: ""
      },
      updateType: "edit",
      updateList: 0,
      updateBlock: false,
      updateForm: {}
    };
  },
  mounted() {},
  methods: {
    dealList(data) {
      // console.log("dealList" ,data)
      for (let i in data) {
        for (let j in operatsList)
          if (data[i].action === operatsList[j].Action) {
            data[i].actionName = operatsList[j].Name;
          }
      }
      return data;
    },
    edit(val) {
      this.updateBlock = true;
      this.updateType = "edit";
      this.updateForm = Object.assign({}, val);
    },
    add() {
      this.updateBlock = true;
      this.updateType = "add";
      this.updateForm = {};
    },
    deletedata(val) {
      let url = "menus/" + val.id + "/";

      this.$confirm("确定删除该权限?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$http["delete"](url, () => {
            this.$baseNotice.message("删除成功");
            this.updateList++;
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    close() {
      this.updateBlock = false;
    }
  }
};
</script>
<style scoped>
.item {
  margin: 10px 30px 0px 0px;
  line-height: 35px;
}
</style>
